import React from "react";

export default function Web_Fullstack() {
  return (
    <div>
      <h1>What is Fullstack</h1>
      <p>
        Route: <code>/web/fullstack</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
